import BaseModel from './BaseModel';

export default class TimeActivity extends BaseModel
{

    static getPrefix()
    {
        return 'planning:time-activity';
    }

    static getEndpoint()
    {
        return window.Planning.endpoints.timeActivity;
    }

    hasProfitabilityDocument()
    {
        return this.getProfitabilityDocumentUuid() !== null;
    }

    getProfitabilityDocumentUuid()
    {
        if ( ! this.worksite ) {
            return null;
        }

        let relation = this.getRelationshipData('trustup-pro-worksite', 'profitability-document');
        if ( relation ) {
            return relation.model_id;
        }

        if ( ! window.App.$store.state.worksite ) {
            return null;
        }

        let profitabilityDocument = window.App.$store.state.worksite.profitability_documents.find(d => (d.external_source === 'timetracker' && d.external_uuid === this.uuid));
        return profitabilityDocument ? profitabilityDocument.uuid : null;
    }

    async previewProfitabilityDocument()
    {
        let uuid = this.getProfitabilityDocumentUuid();
        if ( ! uuid ) {
            console.log(
                'Doesn\'t have a profitability document',
                this.worksite,
                this.getRelationshipData('trustup-pro-worksite', 'profitability-document'),
                window.App.$store.state.worksite.profitability_documents.find(d => (d.external_source === 'timetracker' && d.external_uuid === this.uuid))
            );
            return;
        }

        let profitabilityDocument = await window.Worksite.endpoints.worksiteProfitabilityDocument.setWorksite(this.worksite).retrieve(uuid);
        console.log(profitabilityDocument, uuid);
        profitabilityDocument.preview();
    }
    
    formData()
    {
        return {
            title: this.title,
            worksite: this.worksite,
            worksitePhase: this.worksitePhase,
            starts_at: this.getStartsAt().format('HH:mm'),
            ends_at: this.getEndsAt().format('HH:mm'),
        }
    }

    requestData()
    {
        return {
            user_id: this.user_id,
            title: this.title,
            external_worksite_uuid: this.external_worksite_uuid,
            external_worksite_phase_uuid: this.external_worksite_phase_uuid,
            trustup_io_task_uuid: this.trustup_io_task_uuid,
            starts_at: this.getStartsAt().format('YYYY-MM-DD HH:mm:ss'),
            ends_at: this.getEndsAtOrNull() ? this.getEndsAtOrNull().format('YYYY-MM-DD HH:mm:ss') : null,
            invoiced_at: this.invoiced_at,
            external_invoice_uuid: this.external_invoice_uuid
        }
    }

    getStartTitle()
    {
        let user = this.getUser();

        return user && user.options.time_activity_default_title
            ? user.options.time_activity_default_title
            : window.App.$t('timetracking.activity.default_title');
    }

    getStoppedTitle()
    {
        return window.App.$t('timetracking.activity.default_title_stop');
    }

    hasStartTitle()
    {
        return this.title == this.getStartTitle();
    }

    getTimeDifference(format = 'H:mm:ss')
    {
        return window.moment().startOf('day').seconds(this.getTimeDifferenceInSeconds()).format(format);
    }

    getTimeDifferenceInSeconds()
    {
        return this.getTimeDifferenceIn('seconds');
    }

    getTimeDifferenceInHours()
    {
        return this.getTimeDifferenceIn('hours');
    }

    getTimeDifferenceIn(attribute = 'hours')
    {
        if ( ! this.starts_at ) {
            return 0;
        }

        return this.getEndsAt().diff(this.getStartsAt(), attribute, true);
    }

    getDay()
    {
        return this.getStartsAt().format('YYYY-MM-DD');
    }

    getStartsAt()
    {
        return window.moment(this.starts_at);
    }

    getStartsAtDate()
    {
        if ( ! this.starts_at ) {
            return null;
        }
        
        return this.getStartsAt().format('YYYY-MM-DD');
    }

    getStartsAtTime()
    {
        return this.getStartsAt().format('HH:mm');
    }

    setStartsAtTime(time)
    {
        this.starts_at = window.moment(this.getStartsAt().format('YYYY-MM-DD') + ' ' + time + ':00').format('YYYY-MM-DD HH:mm:ss');
    }

    getEndsAt()
    {
        if ( this.ends_at == 'Invalid date' ) {
            return window.moment();
        }
        return this.ends_at ? window.moment(this.ends_at) : window.moment();
    }

    getEndsAtOrNull()
    {
        if ( this.ends_at == 'Invalid date' ) {
            return null;
        }
        return this.ends_at ? window.moment(this.ends_at) : null;
    }

    getEndsAtDate()
    {
        if ( ! this.ends_at ) {
            return null;
        }

        return this.getEndsAt().format('YYYY-MM-DD');
    }

    getEndsAtTime()
    {
        if ( ! this.ends_at ) {
            return null;
        }
        
        return this.getEndsAt().format('HH:mm');
    }

    setEndsAtTime(time)
    {
        this.ends_at = window.moment(this.getEndsAt().format('YYYY-MM-DD') + ' ' + time + ':00').format('YYYY-MM-DD HH:mm:ss');
    }

    isRunning()
    {
        return this.ends_at == null || this.ends_at == 'Invalid date';
    }

    isCompleted()
    {
        return ! this.isRunning();
    }

    getInvoicePrice()
    {
        let user = this.getUser();
        if ( ! user ) {
            return 0;
        }

        return user.options.hourly_rate * 100;
    }

    getCostPrice()
    {
        let user = this.getUser();
        if ( ! user ) {
            return 0;
        }

        return user.options.hourly_cost * 100;
    }

    getInvoiceQuantity()
    {
        return Math.round(this.getTimeDifferenceInHours() * 100) / 100;
    }

    getTotalCostPrice()
    {
        return this.getInvoiceQuantity() * this.getCostPrice();
    }

    getInvoicablePrice()
    {
        return this.getInvoiceQuantity() * this.getInvoicePrice();
    }

    getInvoiceUrl(uuid = this.external_invoice_uuid)
    {
        if ( ! uuid ) {
            return window.App.$spa.apps.find(app => app.key == 'invoicing').direct_url;
        }
        return `${window.App.$spa.apps.find(app => app.key == 'invoicing').direct_url}/redirection?route=invoices.edit&invoice=${uuid}`;
    }
    
    redirectToLinkedInvoice(uuid = this.external_invoice_uuid)
    {
        window.open(
            this.getInvoiceUrl(uuid),
            '_blank'
        );
    }

    getTotal()
    {
        let hours = this.getTimeDifferenceInHours();
        let user = this.getUser();
        if ( ! user ) {
            return hours;
        }

        return Math.round(hours * user.options.hourly_rate * 100);
    }

    isInvoiced()
    {
        return this.invoiced_at !== null;
    }

    toCalendarEvent()
    {
        return {
            extendedProps: {
                model: this,
                status: this.status,
                user: this.getUser(),
                worksite: this.getWorksite(),
            },
            id: this.id,
            title: this.title,
            start: this.starts_at,
            end: this.ends_at,
            backgroundColor: '#F7F7F7',
            textColor: '#3D3D3D'
        }
    }

    matchesFilters({user, worksite, invoiced_status})
    {
        if ( user !== null && this.user_id !== user ) {
            return false;
        }

        if ( worksite !== null && this.worksite && this.worksite.uuid !== worksite ) {
            return false;
        }

        if ( invoiced_status == 'invoiced' && this.invoiced_at == null ) {
            return false;
        }
        if ( invoiced_status == 'not_invoiced' && this.invoiced_at !== null ) {
            return false;
        }

        return true;
    }

    getLineRef()
    {
        return `timetracker-line-${this.id}`;
    }

}